import { ReactNode } from "react";
import iBtnAnchor from "../../../assets/icons/btn-anchor.svg";
import "./button-anchor.sass";

type Props = {
  children?: ReactNode;
  onClick?: () => void;
  className?: string;
};

const ButtonAnchor = ({ children, onClick, className }: Props) => {
  return (
    <div
      className={`button-anchor ${className ? className : ""}`}
      onClick={onClick}
    >
      <div className="button-anchor__text">{children}</div>

      <img src={iBtnAnchor} className="button-anchor__arrow" alt="" />
    </div>
  );
};

export default ButtonAnchor;
